export const searchNewsTeasers = `query SearchTeaserNewsArticles(
  $filter: SearchableNewsArticleFilterInput
  $limit: Int
  $nextToken: String
) {
  searchNewsArticles (
      filter: $filter,
      sort: {    direction : desc ,field : datePublished },
      limit: $limit,
      nextToken: $nextToken
      )
  {
    items {
      id
      title
      datePublished
      teaserThumbnailUrl
      teaserText
      content
      commentsCount
      category {
        id
      }
      source {
        id
      }
    }
    nextToken
  }
}
`
export const getNewsArticle = `query GetNewsArticle($id: ID!) {
  getNewsArticle(id: $id) {
    id
    title
    datePublished
    teaserThumbnailUrl
    teaserText
    comments {
      items {
        id
        content
      }
      nextToken
    }
    commentsCount
    imageSrcSet
    content
  }
}
`

export const listIndexGerman = `query SearchIndexs {
                                      searchIndexs(
                                        filter: {
                                           or : [
                                           { id : { eq: "DE0008469008" } }
                                           ]
                                        }
                                        sort: {direction: asc, field: name }
                                        limit: 20
                                      ) {
                                        items {
                                          id
                                          name
                                          currency
                                          close
                                          closeDate
                                          closeChange1D
                                          growthRate1M
                                          growthRate1Y
                                          growthRate3Y
                                        }
                                      }
                                    }
                                    `

export const listSharesNameSorted = `query SearchShares(
                                      $filter: SearchableShareFilterInput
                                      $limit: Int
                                      $nextToken: String
                                    ) {
                                      searchShares(
                                        filter: $filter
                                        sort: {direction: asc, field: name}
                                        limit: $limit
                                        nextToken: $nextToken
                                      ) {
                                        items {
                                          id
                                          ric
                                          name
                                          currency
                                          marketCapital
                                          eps
                                          dividendYield
                                          close
                                          closeDate
                                          closeChange1D
                                          growthRate1M
                                          growthRate1Y
                                          growthRate3Y
                                        }
                                        nextToken
                                      }
                                    }
                                    `

export const listSharesEPSSorted = `query SearchShares(
                                      $limit: Int
                                      $nextToken: String
                                    ) {
                                      searchShares(
                                        filter: { inDAX : { eq: true } }
                                        sort: {direction: desc, field: eps}
                                        limit: $limit
                                        nextToken: $nextToken
                                      ) {
                                        items {
                                          id
                                          ric
                                          name
                                          currency
                                          marketCapital
                                          eps
                                          dividendYield
                                          close
                                          closeDate
                                          closeChange1D
                                          growthRate1M
                                          growthRate1Y
                                          growthRate3Y
                                        }
                                        nextToken
                                      }
                                    }
                                    `

export const listSharesPriceChangeSorted = `query SearchShares(
                                      $limit: Int
                                      $nextToken: String
                                    ) {
                                      searchShares(
                                        filter: { inDAX : { eq: true } }
                                        sort: {direction: desc, field: closeChange1D}
                                        limit: $limit
                                        nextToken: $nextToken
                                      ) {
                                        items {
                                          id
                                          ric
                                          name
                                          currency
                                          marketCapital
                                          eps
                                          dividendYield
                                          close
                                          closeDate
                                          closeChange1D
                                          growthRate1M
                                          growthRate1Y
                                          growthRate3Y
                                        }
                                        nextToken
                                      }
                                    }
                                    `

export const listSharesDividendYieldSorted = `query SearchShares(
                                      $limit: Int
                                      $nextToken: String
                                    ) {
                                      searchShares(
                                        filter: { inDAX : { eq: true } }
                                        sort: {direction: desc, field: closeChange1D}
                                        limit: $limit
                                        nextToken: $nextToken
                                      ) {
                                        items {
                                          id
                                          ric
                                          isin
                                          name
                                          currency
                                          countryCode
                                          gicsCode
                                          marketCapital
                                          eps
                                          dividendYield
                                          close
                                          closeDate
                                          closeChange1D
                                          growthRate1M
                                          growthRate1Y
                                          growthRate3Y
                                        }
                                        nextToken
                                      }
                                    }
                                    `

export const listSharesGrowthSorted = `query SearchShares(
                                      $limit: Int
                                      $nextToken: String
                                    ) {
                                      searchShares(
                                        filter: { inDAX : { eq: true } }
                                        sort: {direction: desc, field: growthRate3Y}
                                        limit: $limit
                                        nextToken: $nextToken
                                      ) {
                                        items {
                                          id
                                          ric
                                          name
                                          currency
                                          marketCapital
                                          eps
                                          dividendYield
                                          close
                                          closeDate
                                          closeChange1D
                                          growthRate1M
                                          growthRate1Y
                                          growthRate3Y
                                        }
                                        nextToken
                                      }
                                    }
                                    `

export const listSharesMarketCapitalSorted = `query SearchShares(
                                      $limit: Int
                                      $nextToken: String
                                    ) {
                                      searchShares(
                                        filter: { inDAX : { eq: true } }
                                        sort: {direction: desc, field: marketCapital}
                                        limit: $limit
                                        nextToken: $nextToken
                                      ) {
                                        items {
                                          id
                                          ric
                                          name
                                          currency
                                          marketCapital
                                          eps
                                          dividendYield
                                          close
                                          closeDate
                                          closeChange1D
                                          growthRate1M
                                          growthRate1Y
                                          growthRate3Y
                                        }
                                        nextToken
                                      }
                                    }
                                    `
/*
export const shareTimeSeries1Y = `query getShareTimeSeries1Y($id: ID!) {
                                getShare(id: $id){
                                    id
                                    name
                                    timeSeries1Y { timestamp close }
                                    updatedAt
                                }
                                }`
*/ // TODO: replace date with date one year ago
export const shareTimeSeries1Y = `query getShareTimeSeries1Y($id: ID!) {
                                listTimeSeriesFinancialDatas(
                                  id: $id,
                                  sortDirection:ASC,
                                  timestamp: { gt: "2019-11-19"})
                                  {
                                  items { timestamp close }
                                  }
                                }`

export const getSectorTimeSeries = `
  query GetSectorTimeSeries(
    $sectorId: String!
    $shareId: ID
    $range: String
  ) {
    getSectorTimeSeries(
      sectorId: $sectorId
      shareId: $shareId
      range: $range
    ) {
      timestamp
      value
    }
  }
`
export const instrumentTimeSeries = `query getFinancialDataTimeSeries($instrumentId: String!, $range:String) {
                                getFinancialDataTimeSeries(
                                instrumentId : $instrumentId,
                                range : $range)
                                  {
                                  timestamp close
                                  }
                                }`



// we use the owner GSI to access all user portfolios.
export const myMinimalPortfolios =  /* GraphQL */ `
query listMinimalPortfoliosByOwner( $owner : String! ) {
  listPortfoliosByOwner(owner: $owner, sortDirection: DESC, inclInactive: true) {
    items {
      id
      inactive
      name
      cash
      shareEntries {
        items {
          count
          instrument {
            id
            name
            latestPrice {
              price
              timestamp
              exchangeName
            }
            close
            closeDate
          }
        }
      }
      etfEntries {
        items {
          count
          instrument {
            id
            name
            latestPrice {
              id
              price
              priceChange
              priceChangePercentage
              timestamp
              quality
              exchangeName
            }
            close
            closeDate
          }
        }
      }
      status {
        calculationMessage
        calculationStatus
      }
    }
  }
}
`

export const getPortfolio = /* GraphQL */ `
  query GetPortfolio($id: ID!) {
    getPortfolio(id: $id) {
      id
      inactive
      name
      cash
      deactivateFinAlert
      initialCapital
      initialValue
      createdAt
      updatedAt
      transactions {
        items {
          instrumentType
        }
      }
      assetAllocationActual {
        name
        percentage
      }
      assetAllocationTarget {
        name
        percentage
      }
      etfEntries {
        items {
          id
          assetClass
          count
          averagePrice
          investedCapital
          instrument {
            active
            covered
            delisted
            id
            isin
            assetClass
            name
            latestPrice {
              exchangeName
              quality
              price
              timestamp
            }
            close
            closeDate
            closeChange1D
            finScore
            assetClass
            mainListing {
              id
            }
          }
        }
      }
      shareEntries {
        items {
          id
          assetClass
          count
          averagePrice
          dateAdded
          createdAt
          updatedAt
          owner
          instrument {
            active
            covered
            delisted
            id
            isin
            name
            latestPrice {
              exchangeName
              quality
              price
              timestamp
            }
            close
            closeChange1D
            closeDate
            assetClass
            finScore
            mainListing {
              id
            }
          }
        }
        nextToken
      }
      status {
        calculationStatus
        calculationMessage
      }
      owner
      shareStrategy {
        id
        name
      }
      shareETFStrategy {
        id
        name
      }
      corporateBondsETFStrategy {
        id
        name

      }
      governmentBondsETFStrategy {
        id
        name
      }
      commoditiesETFStrategy {
        id
        name
      }
      shareUniverse {
        id
        name
        orderNumber
        updatedAt
        createdAt
      }
    }
  }
`


export const listPortfolioTransactions = /* GraphQL */ `
  query listPortfolioTransactions(
    $portfolioId: ID!, $instrumentId: ID) {
     listPortfolioTransactions(portfolioId: $portfolioId, instrumentId: $instrumentId) {
      items {
        portfolioId
        actionTimestamp
        payDate
        transaction
        cashAmount
        count
        dps
        planedPrice
        planedFees
        instrumentType
        instrumentId
        invest
        investFees
        realizedPrice
        realizedFees
        realizedTimestamp
        split
        sellStatus
        openCount
        createdAt
        updatedAt
      }
    }
  }
`

export const getBacktrackedPortfolio = /* GraphQL */ `
  query GetBacktrackedPortfolio($portfolioId: ID!, $years: Int!) {
    getBacktrackedPortfolio(portfolioId: $portfolioId, years: $years) {
      id
      name
      cash
      etfEntries {
        items {
          assetClass
          investedCapital
          id
          averagePrice
          count
          dateAdded
          instrument {
            assetClass
            close
            price
            latestPrice {
              price
              timestamp
            }
            id
            isin
            name
            active
            covered
            delisted
          }
        }
      }
      shareEntries {
        items {
          assetClass
          investedCapital
          id
          averagePrice
          count
          dateAdded
          instrument {
            assetClass
            close
            price
            latestPrice {
              price
              timestamp
            }
            id
            isin
            name
            active
            covered
            delisted
          }
        }
      }
      timeSeries {
        currentValue
        timestamp
        result
        yield
        dividend
      }
    }
  }
`

export const getPortfolioTimeSeriesRTLastValues = /* GraphQL */ `
query getPortfolioTimeSeriesRTLastValues($portfolioId: ID!, $assetClass: String!) {
  getPortfolioRatioDataRealTime(portfolioId: $portfolioId, assetClass: $assetClass) {
        currentValue
        yield
        yield1D
        yield1Y
        growthRate
        growthAmount
        growthAmount1M
        growthAmount1Y
        timestamp
  }
}
`


export const getPortfolioTimeSeriesRT = /* GraphQL */ `
  query GetPortfolio($id: ID!, $assetClass: String) {
    getPortfolio(id: $id) {
      id
      timeSeriesRT(assetClass: $assetClass) {
        portfolioId
        assetClass
        currentValue
        yield
        yield1Y
        growthRate
        growthAmount
        growthAmount1M
        growthAmount1Y
        createdAt
        updatedAt
        timestamp
        owner
      }
    }
  }
`
export const getMinimalPortfolio = /* GraphQL */ `
  query GetPortfolio($id: ID!) {
    getPortfolio(id: $id) {
      id
      name
      cash
      shareEntries {
        items {
          count
          dateAdded
          instrument {
            id
            name
            latestPrice {
              price
              exchangeName
              timestamp
            }
            close
            closeDate
          }
        }
      }
      etfEntries {
        items {
          count
          dateAdded
          instrument {
            id
            name
            latestPrice {
              id
              price
              priceChange
              priceChangePercentage
              timestamp
              quality
              exchangeName
            }
            close
            closeDate
          }
        }
      }
      status {
        calculationMessage
        calculationStatus
      }
    }
  }
`

export const getSamplePortfolio = /* GraphQL */ `
  query GetSamplePortfolio($input: ModelSamplePortfolioInput!) {
    getSamplePortfolio(input: $input){
      SHARE {
        assignedCapital
        instruments {
          count
          instrument {
            id
            name
            isin
            assetClass
            close
            latestPrice{ timestamp price exchangeName }
            exchange { id name }
          }
        }
      }
      SHARE_ETF {
        assignedCapital
        instruments {
          count
          instrument {
            id
            name
            isin
            assetClass
            close
            latestPrice{ timestamp price exchangeName }
            exchange { id name }
          }
        }
      }
      CORPORATE_BONDS_ETF {
        assignedCapital
        instruments {
          count
          instrument {
            id
            name
            isin
            assetClass
            close
            latestPrice{ timestamp price exchangeName }
            exchange { id name }
          }
        }
      }
      GOVERNMENT_BONDS_ETF {
        assignedCapital
        instruments {
          count
          instrument {
            id
            name
            isin
            assetClass
            close
            latestPrice{ timestamp price exchangeName }
            exchange { id name }
          }
        }
      }
      COMMODITIES_ETF {
        assignedCapital
        instruments {
          count
          instrument {
            id
            name
            isin
            assetClass
            close
            latestPrice{ timestamp price exchangeName }
            exchange { id name }
          }
        }
      }
    }
  }
`

export const getUserPortfolios = `query GetUser($id: ID!) {
  getUser(id: $id) {
    portfolios {
      items {
        id
        name
        cash
        initialCapital
        initialValue
        createdAt
        updatedAt
        timeSeriesRT {
          portfolioId
          assetClass
          currentValue
          yield
          yield1Y
          growthRate
          growthAmount
          growthAmount1M
          growthAmount1Y
          createdAt
          updatedAt
          owner
        }
        etfEntries {
          items {
            id
            assetClass
            count
            averagePrice
            investedCapital
            instrument {
              id
              name
              isin
              close
              closeChange1D
            }
          }
        }
        shareEntries {
          items {
            id
            count
            averagePrice
            assetClass
            instrument {
              id
              name
              isin
              close
              closeChange1D
              assetClass
            }
          }
        }
      }
     }
  }
}
`
export const validateBuySellTransactions = /* GraphQL */ `
  query Validate($input: PortfolioTransactionInput, $transactionType: TransactionType) {
    validateBuySellTransactions(input: $input, transactionType: $transactionType) {
      isValid
      cash
      cashDeficit
      causes {
        actionTimestamp
        cashDeficit
        instrumentId
        message
        transactionType
      }
    }
  }
`

export const getPortfolioComposition = `query GetPortfolio($id: ID!) {
    getPortfolio(id: $id) {
     transactions{
        items{
          transaction
          cashAmount
          actionTimestamp
          updatedAt
          createdAt
        }
      }
      etfEntries {
        items {
          id
          assetClass
          count
          averagePrice
          dateAdded
          investedCapital
          instrument {
              id
              ric
              isin
              name
          }
        }
      }
      shareEntries {
        items {
          id
          count
          averagePrice
          assetClass
          dateAdded
          instrument {
              id
              ric
              isin
              name
              assetClass
          }
        }
      }
    }
  }
`

export const getMinimalShare = `
query GetMinimalShare($id: ID!) {
  getShare(id: $id) {
    assetClass
    close
    closeDate
    latestPrice {
      price
      timestamp
      exchangeName
    }
    id
    isin
    name
  }
}
`

export const getShareCompany = `
query GetShareCompany($id: ID!) {
  getShare(id: $id) {
    active
    covered
    delisted
    id
    assetClass
    name
    isin
    dividendYield
    marketCapital
    close
    closeDate
    closeChange1D
    closeChangeAbsolute1D
    closeChangeYTD
    latestPrice{
      quality
      price
      timestamp
      exchangeName
      open
      high
      low
      priceChange
      priceChangePercentage
    }
    timeSeriesRT{
      close:price
      priceChange
      timestamp
    }
    closeChange1W
    closeChange1M
    closeChange3M
    closeChange6M
    closeChange1Y
    closeChange3Y
    closeChange5Y
    closeChange10Y
    trailingReturn1Y
    trailingReturn3Ypa
    trailingReturn5Ypa
    trailingReturn10Ypa
    trailingReturnYTD
    peRatio
    peRatioEstimated
    revenue
    open
    volume
    mainListing {
      timeSeries {
        timestamp
        close
      }
    }
    portfolioEntries{
      items{
        portfolio{
          id
          name
        }
      }
    }
  }
}
`

export const getShareKeyFigures = `
query GetShareKeyFigures($id: ID!) {
  getShare(id: $id) {
    keyFigures {
      group
      name
      rows {
        cols {
          n
          v
        }
        id
        order
        financialDataItem {
          name
          unit
        }
      }
    }
  }
}
`

export const getMinimalEtf = `
query GetMinimalEtf($id: ID!) {
  getEtf(id: $id) {
    assetClass
    close
    closeDate
    latestPrice {
      price
      exchangeName
      timestamp
    }
    id
    isin
    name
  }
}
`

export const getEtf = `
query GetEtf($id: ID!) {
  getEtf(id: $id) {
      active
      covered
      delisted
      assetClass
      averageMarketCap
      brandName
      issuer
      cashFlowFrequency
      close
      closeDate
      closeChange1D
      closeChangeAbsolute1D
      closeChange1W
      closeChange1M
      closeChange3M
      closeChange6M
      closeChangeYTD
      closeChange1Y
      closeChange3Y
      closeChange5Y
      closeChange10Y
      country{
        id
        name
      }
      currency
      description
      dividend
      dividend1Y
      dividendDate
      expenseRatio
      fundCategory
      fundHomepage
      fundFocus
      fundNiche
      fundNicheCode
      finScore
      hedged
      hedgedInto
      hedgedFrom
      id
      indexName
      isin
      legalStructure
      launchDate
      regionCountry
      replicationMethod
      sectorTopic
      sizeStyle
      strategy
      latestPrice{
        price
        high
        low
        open
        timestamp
        exchangeName
      }
      mainListing {
        timeSeries {
          timestamp
          close
        }
      }
      timeSeriesRT{
        close:price
        priceChange
        timestamp
      }
      name
      provider
      volume
      volatility3Y
      beta3Y
      alpha3Y
      yield
      yieldRisk3Y
      trailingReturn1Y
      trailingReturn3Ypa
      trailingReturn5Ypa
      trailingReturn10Ypa
      trailingReturnYTD
      dividendTreatment
  }
}
`

export const deletePortfolioShareEntry = /* GraphQL */ `
  mutation DeletePortfolioShareEntry(
    $input: DeletePortfolioShareEntryInput!
  ) {
    deletePortfolioShareEntry(input: $input) {
      id
    }
  }
`

export const deletePortfolioEtfEntry = /* GraphQL */ `
  mutation DeletePortfolioEtfEntry(
    $input: DeletePortfolioEtfEntryInput!
  ) {
    deletePortfolioEtfEntry(input: $input) {
      id
    }
  }
`

export const searchShareScreenerShares = function (dynamicFields) {
  // eslint-disable-next-line no-unexpected-multiline
  const additionalFields = dynamicFields ? dynamicFields.join('\n') : ''

  return `
  query SearchShares(
    $filter: SearchableShareFilterInput
    $sort: SearchableShareSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchShares(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        active
        covered
        delisted
        id
        name
        close
        closeDate
        latestPrice {
          price
          timestamp
          exchangeName
        }
        gicsCode
        currency
        isin
        countryCode
        country {
          name
          alpha2Code
        }
        assetClass
        ${additionalFields}
      }
      nextToken
      total
    }
  }
`
}

export const searchEtfScreenerEtfs = function (dynamicFields) {
  // eslint-disable-next-line no-unexpected-multiline
  const additionalFields = dynamicFields ? dynamicFields.join('\n') : ''

  return `
  query SearchEtfs(
    $filter: SearchableEtfFilterInput
    $sort: SearchableEtfSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchEtfs(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        active
        covered
        delisted
        id
        name
        close
        closeDate
        assetClass
        isin
        currency
        ${additionalFields}
        latestPrice {
          price
          timestamp
          exchangeName
        }
        currency
        isin
        countryCode
        country {
          name
          alpha2Code
        }
      }
      nextToken
      total
    }
  }
`
}


export const getScreenerResultColumns = /* GraphQL */ `
  query getScreenerResultColumns($assetClass: AssetClass!) {
    getScreenerResultColumns(assetClass: $assetClass)
  }
`


export const searchFinancialDataHistograms = function (dynamicFields) {
  // eslint-disable-next-line no-unexpected-multiline
  const additionalFields = dynamicFields ? dynamicFields.join('\n') : ''

  return `
  query SearchFinancialDataHistograms(
    $filter: SearchableFinancialDataHistogramFilterInput
    $sort: SearchableFinancialDataHistogramSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchFinancialDataHistograms(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        financialDataHistogramDataItemId
        ${additionalFields}
        binCount
        binFirst
        binLast
        binInterval
        bins
      }
      nextToken
      total
    }
  }
`
}

export const getScreenerConfigurationById = /* GraphQL */ `
  query GetScreenerConfigurationById(
    $id: ID!
  ) {
    getScreenerConfiguration(
      id: $id
    ) {
      id
      name
      inactive
      lastHits
      lastHitsUpdated
      sector {
        id
        name
        level
      }
      screenerConfigurationSectorId
      region {
        id
        name
        level
      }
      screenerConfigurationRegionId
      marketCapCategory {
        id
        name
      }
      screenerConfigurationMarketCapCategoryId
      filters{
        items{
          id
          min
          max
          item{
            id
            itemId
            name
            shortName
            unit
          }
        }
      }
      valueFilters {
          items{
            id
            values
            item{
              id
              itemId
              name
              shortName
              unit
              displayType
              tableQuery
              tablePath
              tableOrder
            }
          }
      }
    }
  }
`

export const listScreenerConfigurations = /* GraphQL */ `
  query ListScreenerConfigurations(
    $filter: ModelScreenerConfigurationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOwnerScreenerConfiguration(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      inclInactive: true
    ) {
      items {
        id
        name
        inactive
        lastHits
        lastHitsUpdated
        sector {
          id
          name
          level
        }
        screenerConfigurationSectorId
        region {
          id
          name
          level
        }
        screenerConfigurationRegionId
        marketCapCategory {
          id
          name
        }
        screenerConfigurationMarketCapCategoryId
        filters{
          items{
            id
            min
            max
            item{
              id
              itemId
              name
              shortName
              unit
            }
          }
        }
        valueFilters {
          items{
            id
            values
            item{
              id
              itemId
              name
              shortName
              unit
              displayType
            }
          }
        }
      }
      nextToken
    }
  }
`

export const getEtfScreenerConfigurationById = /* GraphQL */ `
  query GetEtfScreenerConfiguration(
    $id: ID!
  ) {
    getEtfScreenerConfiguration(id: $id) {
      id
      name
      inactive
      lastHits
      lastHitsUpdated
      assetClass
      rangeFilters{
        items{
          id
          min
          max
          item{
            id
            itemId
            name
            shortName
            unit
            displayType
          }
        }
      }
      valueFilters {
        items{
          id
          values
          item{
            id
            itemId
            name
            shortName
            unit
            displayType
          }
        }
      }
      resultColumns
    }
  }
`

export const getFinancialDataItemFilterValuesByIdAndAssetClass = /* GraphQL */`
  query GetFinancialDataItem(
    $finDataItemID: ID!
    $assetClassID: String!
  ) {
    getFinancialDataItem(id: $finDataItemID){
      filterValues(assetClass: $assetClassID){
        id
        values {
          id
          name
        }
      }
    }
  }
`

export const listEtfScreenerConfigurations = /* GraphQL */ `
  query ListEtfScreenerConfigurations(
    $filter: ModelEtfScreenerConfigurationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOwnerEtfScreenerConfiguration(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      inclInactive: true
    ) {
      items {
        id
        name
        inactive
        lastHits
        lastHitsUpdated
        assetClass
        rangeFilters{
          items{
            id
            min
            max
            item{
              id
              itemId
              name
              shortName
              unit
              displayType
            }
          }
        }
        valueFilters {
          items{
            id
            values
            item{
              id
              itemId
              name
              shortName
              unit
              displayType
            }
          }
        }
        resultColumns
      }
      nextToken
    }
  }
`

export const searchMarketCapitalizationCategorys = /* GraphQL */ `
  query SearchMarketCapitalizationCategorys(
    $filter: SearchableMarketCapitalizationCategoryFilterInput
    $sort: SearchableMarketCapitalizationCategorySortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchMarketCapitalizationCategorys(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        name
    }
  }
  }
`

export const myWatchlists = /* GraphQL */ `
query listOwnerWatchlist( $owner : String! ) {
  listOwnerWatchlist(owner: $owner, inclInactive: true) {
      items {
        id
        name
        inactive
        updatedAt
        watched {
          items {
            watchlistId
            instrumentId
            alertActive
            upperLimit
            lowerLimit
            createdAt
            updatedAt
            owner
            share {
              assetClass
              latestPrice {
                id
                price
                priceChange
                priceChangePercentage
                timestamp
                quality
              }
              close
              closeChange1D
              closeChangeAbsolute1D
              id
              name
              mainListing {
                timeSeries1M {
                  timestamp
                  close
                }
              }
            }
            etf {
              assetClass
              latestPrice {
                id
                price
                priceChange
                priceChangePercentage
                timestamp
                quality
              }
              close
              closeChange1D
              closeChangeAbsolute1D
              id
              name
              mainListing {
                timeSeries1M {
                  timestamp
                  close
                }
              }
            }
          }
          nextToken
        }
      }
      nextToken
    }
  }
`


export const getWatchlist = /* GraphQL */ `
  query getWatchlist( $id: ID! ) {
    getWatchlist(id : $id ) {
      id
      name
      inactive
      watched{
        items{
          watchlistId
          instrumentId
          alertActive
          upperLimit
          lowerLimit
          exceeded {
            upperLimit
            lowerLimit
            price
            timestamp
          }
          share{
            active
            covered
            delisted
            name
            id
            isin
            latestPrice {
              id
              price
              priceChange
              priceChangePercentage
              high
              low
              timestamp
              quality
              exchangeName
            }
            close
            closeDate
            high
            low
            closeChange1D
            closeChangeAbsolute1D
            assetClass
          }
          etf{
            active
            covered
            delisted
            name
            id
            isin
            latestPrice {
              id
              price
              priceChange
              priceChangePercentage
              high
              low
              timestamp
              quality
              exchangeName
            }
            close
            closeDate
            closeChange1D
            closeChangeAbsolute1D
            assetClass
            high
            low
          }
        }
      }}}`

export const searchSectors = /* GraphQL */ `
    query SearchSectors(
    $filter: SearchableSectorFilterInput
    $sort: SearchableSectorSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchSectors(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        level
      }
      nextToken
      total
    }
  }
`
export const screenerPositionGroups = function (assetClass) {

  return `
query screenerPositionGroups( $groupId : ID!){
 getPositionGroup(id: $groupId){
    groupId
    name
    lexiconEntry
    entries {
      items {
        isSubGroup
        orderNumber
        dataItem { id itemId name lexiconEntry}
        subPosGroup  {
          groupId
          name
          lexiconEntry
          entries(filter: { positionGroupMemberDataItemId: {ne: "default"} }) {
            items {
              isSubGroup
              orderNumber
              dataItem {
                id
                itemId
                displayType
                name
                shortName
                lexiconEntry
                unit
                minValue
                maxValue
                histograms {
                  items {
                    id
                  }
                }
                filterValues(assetClass: "${assetClass}") {
                  id
                  values {
                    id
                    name
                    orderNumber
                  }
                }
              }
            }
          }
        }
        isSubGroup
        orderNumber
      }
    }
  }
}
`
}

export const listSpeakerAdminMessages = /* GraphQL */`
  query listSpeakerMessages(
    $filter: ModelSpeakerMessageFilterInput
    $limit: Int
    $nextToken: String
  )
    {
      gr_listSpeakerMessages(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    )
      {
        items{
           id
           title
           text
           type
           createdAt
           approvalNeeded
           allowComments
           approved
           status
        }
        nextToken
      }
    }
`

export const getSpeakerAdminMessage = /*GraphQL */  `
    query getSpeakerAdminMessage( $id: ID! )
    {
      gr_listSpeakerMessages(
        filter: {
          id: {
            eq: $id
          }
        }
      )
      {
        items{
          id
          title
          text
          type
          createdAt
          approvalNeeded
          allowComments
          approved
          status
        }
      }
    }
`


export const getSpeakerUserMessages = /* GraphQL */ `
  query listOwnerSpeakerMessageRecipient(
    $filter: ModelSpeakerMessageRecipientFilterInput
    $limit: Int
    $nextToken: String
    $owner: String
    )
    {
      listOwnerSpeakerMessageRecipient(
        filter: $filter
        limit: $limit
        nextToken: $nextToken
        owner: $owner
        sortDirection: DESC
      )
      {
        nextToken
        items{
          id
          receivedAt
          readAt
          createdAt
          owner
          status
          message{
            id
            title
            text
            type
            createdAt
            approved
          }
        }
      }
    }
`

export const getSpeakerUserUnreadMessages = /* GraphQL */ `
  query GetSpeakerUserUnreadMessages(
      $limit: Int
      $nextToken: String
      $owner: String
    )
    {
      listOwnerSpeakerMessageRecipientByStatus(
        filter: {status: {eq: "UNREAD"}}
        limit: $limit
        nextToken: $nextToken
        owner: $owner
        sortDirection: DESC
      )
      {
        items{
          id
          receivedAt
          readAt
          createdAt
          owner
          status
          message{
            id
            title
            text
            type
            createdAt
            approved
          }
        }
        nextToken
      }
    }
`

export const sortedDemoToolAssets = `
  query sortedDemoToolAssets
  {
    searchDemoToolAssets(
      filter: {
        assetType: {eq : "ASSET" }
        dataCount: {gt : 0 }
      },
      sort: {
        field : orderNo, direction: asc
      }
    )
    {
      items {
        id
        name
        nameSupplement
        description
        dataCount
        data {
          timestamp
          value
        }
      }
    }
  }
`
export const getDemoToolSparplanzinsen = `
  query getDemoToolSparplanzinsen {
    getDemoToolAsset(id: 0){
        description
        data{
            timestamp
            value
        }
    }
  }
`

export const sortedArchetypeClassifications = `
query sortedArchetypeClassifications{
      searchArchetypeClassifications(
        sort:  {direction: asc, field:id}
      ){
        items {
        id
        name
        icon
        question
        title
        values {
          id
          title
          tooltip{title text}
        }
      }
    }
  }
`

export const sortedArchetypesPublic = `
query sortedArchetypes{
  searchArchetypes(
    sort:  { direction: asc, field:sortOrder })
    { items
      {
        id
        title
        img
        scene
        animation
        confirmationText
        shortDescription
        description
        matrixCode
        alternativeMatrixCodes
        classification {
          investmentObjective
          investmentHorizon
          attitudeToRisk
          levelOfKnowledge
          timeIntensity
          activeLevel
        }
        assetAllocation {
          name
          percentage
        }
      }
    }
  }
`


export const sortedArchetypes = `
query sortedArchetypes{
  searchArchetypes(
    sort:  { direction: asc, field:sortOrder })
      {items {
        id
        title
        img
        scene
        animation
        confirmationText
        shortDescription
        description
        matrixCode
        alternativeMatrixCodes
        classification {
          investmentObjective
          investmentHorizon
          attitudeToRisk
          levelOfKnowledge
          timeIntensity
          activeLevel
        }
        assetAllocation {
          name
          percentage
        }
        mainStrategyShare {
          id
          name
          description
          riskCategories
          communityRanking
          approach
          ruleDescription
          rules
        }
        etfStrategyModels {
          items {
            strategyModelId
            etfStrategyModel {
              name
              assetClass
            }
          }
        }
      shareStrategyModels {items{
        shareStrategyModel{
          id
          name
          description
          riskCategories
          communityRanking
          approach
          ruleDescription
          rules
          category {
            id
            name
            description
          }
          archetypes {
            items {
              id
            }
          }
        }
      }}
    }}
  }
`


export const shareStrategyDetailsById = `
  query strategyDetails($id: ID!){
    getShareStrategyModel(id: $id) {
      id
      description
      name
      riskCategories
      approach
      ruleDescription
      rules
      category {
        id
        name
      }
      archetypes {
        items {
          archetype {
            id
            img
            title
          }
        }
        nextToken
      }
      matchingShares(sortDirection: DESC) {
        items{
          finScore
          share {
            id
            isin
            ric
            name
            currency
            marketCapital
            countryCode
            gicsCode
            eps
            dividendYield
            close
            closeDate
            closeChange1D
            growthRate1M
            growthRate1Y
            growthRate3Y
          }
        }
      }
    }
  }
`

export const etfStrategyDetailsById = `
  query strategyDetails($id: ID!){
    getEtfStrategyModel(id: $id) {
      id
      description
      name
      riskCategories
      category {
        id
        name
      }
      archetypes {
        items {
          archetype {
            id
            img
            title
          }
        }
        nextToken
      }
      matchingEtf(sortDirection: DESC) {
        items{
          strategyModelId
          finScore
          instrumentId
          updatedAt
          createdAt
          etf {
            close
            countryCode
            currency
            id
            isin
          }
        }
      }
    }
  }
`

export const listShareStrategyCategories = /* GraphQL */ `
  query ListShareStrategyCategories(
    $filter: ModelShareStrategyCategoryFilterInput
  ) {
    listShareStrategyCategorys(filter: $filter) {
      items {
        createdAt
        description
        id
        name
      }
    }
  }
`

export const listShareStrategyModels = /* GraphQL */ `
  query ListShareStrategyModels(
    $limit: Int
    $nextToken: String
  ) {
    listShareStrategyModels(filter: { or: [{status: {eq: FINAL}}, {status: {eq: COMING_SOON}}] }, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        riskCategories
        category {
          id
        }
        archetypes {
          items{
            archetypeID
          }
          nextToken
        }
      }
      nextToken
    }
  }
`

export const listEtfStrategyModels = /* GraphQL */ `
  query listEtfStrategyModels(
    $filter: ModelEtfStrategyModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEtfStrategyModels(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        assetClass
        category {
          id
        }
        archetypes {
          items{
            archetypeID
          }
          nextToken
        }
      }
      nextToken
    }
  }
`

export const listDashboardShareScreeners = /* GraphQL */ `
  query listDashboardShareScreeners(
    $limit: Int
  ) {
    listOwnerScreenerConfiguration(
      limit: $limit, inclInactive: true)
    {
      items {
        name
        id
        inactive
      }
    }
  }
`

export const listDashboardEtfScreeners = /* GraphQL */ `
  query listDashboardEtfScreeners(
    $limit: Int
  ) {
    listOwnerEtfScreenerConfiguration(
      limit: $limit, inclInactive: true)
    {
      items {
        name
        id
        inactive
      }
    }
  }
`

export const listMyHubToolShareRatings = /* GraphQL */ `
  query listOwnerShareRating(
    $limit: Int
    $nextToken: String
  ) {
    listOwnerShareRating( limit: $limit, nextToken: $nextToken, inclInactive: true) {
      items {
        id
        name
        ratedAt
        inactive
        share {
          active
          covered
          delisted
        }
      }
    }
  }
`

export const searchTopLevelRegions = /* GraphQL */ `
  query SearchRegions(
    $nextToken: String
    $from: Int
  ) {
    searchRegions(
      filter: { level : { eq : 0 } , shareActive : { eq : true } }
      sort: { field : name, direction :  asc }
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        name
        level
        alpha2Code
      }
      nextToken
      total
    }
  }
`
export const searchTopLevelSectors = /* GraphQL */ `
  query SearchSectors(
    $nextToken: String
    $from: Int
  ) {
    searchSectors(
      filter: { level : { eq : 0 } , shareActive : { eq : true }, provider : { eq : "factset" } }
      sort: { field : name, direction :  asc }
      nextToken: $nextToken
      from: $from
    ) {
      items {
        id
        name
        level
      }
      nextToken
      total
    }
  }
`
export const getPortfolioDistribution = /*graphQL*/ `
  query GetPortfolioDistribution(
    $portfolioId: ID!
  ) {
  getPortfolio(
    id: $portfolioId
  ) {
      id
      distributions {
        assetClass
        distribution {
          name
          percentage
        }
      }
  }
}
`

export const getPortfolioDistributionByAssetClass = /*graphQL*/ `
  query GetPortfolioDistributionByAssetClass(
    $portfolioId: ID,
    $assetClass: AssetClass
  ) {
  getPortfolioDistribution(
    portfolioId: $portfolioId
    assetClass: $assetClass
  ) {
      name
      percentage
  }
}
`

// TODO remove not needed fields
export const searchStrategyInstruments = /*graphQL*/ `
  query SearchStrategyInstruments(
    $filter: SearchableStrategyInstrumentFilterInput
    $from: Int
    $limit: Int
    $sort: SearchableStrategyInstrumentSortInput
  ) {
  searchStrategyInstruments(
    filter: $filter
    from: $from
    limit: $limit
    sort: $sort
  ) {
    total
    items {
      instrumentId
      strategyId
      finScore
      instrument {
      ... on ShareInstrument {
          active
          covered
          delisted
          id
          assetClass
          isin
          name
          country {
            id
            name
          }
          close
          closeDate
          latestPrice {
            exchangeName
            price
            timestamp
          }
          sector {
            name
          }
          sectorSustainability {
            name
          }
          sectorExclusion {
            name
          }
          peRatio
          dividendYield
          epsGrowth1Y
          ebitMargin
        }
      ... on EtfInstrument {
          id
          assetClass
          name
          isin
          close
          closeDate
          latestPrice {
            exchangeName
            price
            timestamp
          }
          volume
          launchDate
          dividendTreatment
          dividend
          expenseRatio
          trailingReturn1Y
          trailingReturn3Ypa
          trailingReturn5Ypa
          yield
          country {
            id
            name
          }
        }
      }
    }
  }
}
`
export const getAdminUser = /*graphQL*/ `
  query GetPortfolioDistributionByAssetClass(
    $portfolioId: ID,
    $assetClass: AssetClass
  ) {
  getPortfolioDistribution(
    portfolioId: $portfolioId
    assetClass: $assetClass
  ) {
      name
      percentage
  }
}
`


export const getRankedShares = /* GraphQL */ `
  query ListMatchingSharesByStrategy(
    $strategyModelID: ID
    $finScore: ModelFloatKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStrategyMatchingShareFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMatchingSharesByStrategy(
      strategyModelID: $strategyModelID
      finScore: $finScore
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        strategyModelId
        finScore
        instrumentId
        createdAt
        updatedAt
        share {
          assetClass
          id
          name
          currency
          isin
          company {
            sectorLevel0 {
              name
            }
          }
          countryCode
          country {
            name
            alpha2Code
          }
          eps
          epsGrowth1Y
          close
          closeOrg
          closeDate
          closeChange1D
          closeChange1W
          closeChange1M
          closeChange3M
          closeChange6M
          closeChange1Y
          closeChangeAbsolute1D
          closeChangeAbsolute1W
          closeChangeAbsolute1M
          closeChangeAbsolute3M
          closeChangeAbsolute6M
          closeChangeAbsolute1Y
          dividendYield
          gicsCode
          marketCapital
          peRatio
          ebitMargin
        }
      }
      nextToken
    }
  }
`

export const getRankedEtfs = /* GraphQL */ `
  query ListMatchingEtfsByStrategy(
    $etfStrategyModelID: ID
    $finScore: ModelFloatKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelStrategyMatchingEtfFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMatchingEtfsByStrategy(
      etfStrategyModelID: $etfStrategyModelID
      finScore: $finScore
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        strategyModelId
        finScore
        instrumentId
        createdAt
        updatedAt
        etf {
          assetClass
          id
          name
          provider
          countryCode
          strategy
          currency
          isin
          ric
          open
          high
          low
          volume
          close
          closeDate
          highY
          highYDate
          lowY
          lowYDate
          closeChange1D
          closeChangeAbsolute1D
          closeChange1W
          closeChange1M
          closeChange3M
          closeChange6M
          closeChange1Y
          createdAt
          updatedAt
        }
        etfStrategyModel {
          id
          name
          description
          riskCategories
          assetClass
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`

export const searchSortedShareStrategyCategories = /* GraphQL */ `
  query SearchShareStrategyCategorys {
    searchShareStrategyCategorys(sort: {direction: asc, field: sortOrder}) {
      items {
        id
        name
      }
    }
  }
`

export const searchSortedEtfStrategyCategories = /* GraphQL */ `
  query SearchEtfStrategyCategorys {
    searchEtfStrategyCategorys(sort: {field: sortOrder, direction: asc}) {
      items {
        id
        name
      }
    }
  }
`
export const searchUniverses = /* GraphQL */ `
  query SearchUniverses {
  searchUniverses(sort: {field: orderNumber, direction: asc}) {
    items {
      id
      name
      orderNumber
      createdAt
      updatedAt
    }
    total
    nextToken
  }
}
`

export const searchSharesFilteredAndSorted = /* GraphQL */ `
  query searchSharesFilteredAndSorted(
    $filter: SearchableShareFilterInput
    $sort: SearchableShareSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchShares(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        active
        covered
        delisted
        id
        name
        assetClass
        latestPrice {
          price
          timestamp
          exchangeName
        }
        close
        closeDate
        gicsCode
        currency
        isin
        countryCode
        country {
          name
          alpha2Code
        }
      }
      nextToken
      total
    }
  }
`

export const searchETFs = function (dynamicFields) {
  // eslint-disable-next-line no-unexpected-multiline
  const additionalFields = dynamicFields ? dynamicFields.join('\n') : ''

  return `
  query SearchEtfs(
    $filter: SearchableEtfFilterInput
    $sort: SearchableEtfSortInput
    $limit: Int
    $nextToken: String
    $from: Int
  ) {
    searchEtfs(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
    ) {
      items {
        active
        covered
        delisted
        id
        isin
        name
        assetClass
        latestPrice {
          price
          timestamp
          exchangeName
        }
        close
        closeDate
        countryCode
        ${additionalFields}
      }
      nextToken
      total
    }
  }
`
}

export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      paymentDeadline
      paymentStatus
      title
      salutation
      lastname
      firstname
      username
      email
      newsletter
      dateOfBirth
      address {
        street
        streetNo
        city
        zipCode
        country
      }
      image
      archetypeUpdatedAt
      onboarding
      documentsToAccept: documents(filter: {
        isAccepted: false
        isAcceptRequired: true
      }){
        documentId
        acceptedAt
        isPrivate
        version
        comment
        fileName
        createdAt
        updatedAt
      }
      archetype {
        id
        title
        img
        scene
        animation
        confirmationText
        shortDescription
        description
        matrixCode
        alternativeMatrixCodes
        classification {
          investmentObjective
          investmentHorizon
          attitudeToRisk
          levelOfKnowledge
          timeIntensity
          activeLevel
        }
        assetAllocation {
          name
          percentage
        }
      }
      groupId
      groupQuota
      group {
        id
        name
        priceModel {
          id
          description
          order
          price
          nextPriceModel { id description price }
          permissions {
            feature { id description }
            enabled
            limited
            levels { id description }
          }
        }
      }
      stripeId
      subscriptionChange
      subscriptionChangeDate
    }
  }
`


export const getUserAboPaymentDeadlines = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      paymentDeadline
    }
  }
`

export const getLatestGeneralTerms = /* GraphQL */ `
  query GetLatestGeneralTerms {
    getLatestGeneralTerms {
      documentId: id
      version
      fileName
      comment
      createdAt
    }
  }`

export const getDataProtectionFirstInfoDoc = /* GraphQL */ `
  query getBafinDocs {
    bafin1: getLatestGeneralTerms(id: "bafin01"){
      id
      version
      fileName
      createdAt
      comment
    }
  }`

export const getBafinDocArchetypeClassifications = /* GraphQL */ `
  query GetBafinDocArchetypeClassifications {
    searchArchetypeClassifications(filter: {id: {lte: "3"}}, sort: {field: id, direction: asc}) {
      items {
        name
        values {
          id
          tooltip {
            title
          }
        }
      }
    }
  }`

export const listArchetypes = /* GraphQL */ `
  query ListArchetypes(
    $filter: ModelArchetypeFilterInput
  ) {
    listArchetypes(filter: $filter) {
      items {
        id
        title
        img
      }
    }
  }
`

export const getSpeakerMessageRecipient = /* GraphQL */ `
  query GetSpeakerMessageRecipient($id: ID!) {
    getSpeakerMessageRecipient(id: $id) {
      id
      message {
        id
        broadcastMessage
        type
        title
        text
        approvalNeeded
        approved
        allowComments
        status
        displayUntil
      }
    }
  }
`

export const getSystemStatus = `
query getSystemStatus($id: ID!) {
  getSystemStatus(id: $id) {
    id
    name
    status
  }
}
`

export const testVersionQuery = `
query testVersion {
  getVersion{
    currentVersion
    compatibleVersion
  }
}
`
